VGTierApp.PDPage.DisplayTiers = function () {
    this.DisplayTiersFn = function () {
        jQuery('#tieres').remove();
        var selectedVariant_ = jQuery('input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]', jQuery('form[action="/cart/add"]')).val();
        if (selectedVariant_ != null) {
            var tiered_ = commonFields_PD.variantsMFArray_PD[selectedVariant_];
            if (tiered_ != "" && tiered_ != undefined) {
                var tieredSplit_ = tiered_.split(",");
                if (tieredSplit_[5] === 'true') {
                    if (globalFields.StartEndDateValid(tieredSplit_)) {
                        WriteTableHeading(tieredSplit_);
                        WriteTableRows(tieredSplit_, selectedVariant_);
                    }
                }
            }
        }
    }

    this.OnVariantChange = function () {
        setTimeout(function () {
            $(".single-option-selector,.single-option-selector__radio").change(function () {
                displayTiers.DisplayTiersFn();
            });
        }, 2000);
    }

    var WriteTableHeading = function (tieredSplit_) {
        var tieredType = tieredSplit_[0].trim();
        var tableSelector = 'form[action="/cart/add"] button[type=submit]';
        if (commonFields_PD.tableSetting == "table1") {
            jQuery(tableSelector).before('<div id="tieres" class="table-first"><table><thead><tr><th class="custom-block1 heading">' + commonFields_PD.headerText1Value + '</th><th class="custom-block2 heading">' + commonFields_PD.headerText2Value + '</th></tr></thead><tbody id="table-1-data"></tbody></table></div>');
        }
        if (commonFields_PD.tableSetting == "table2") {
            var tbl2Hdr3Vlu = commonFields_PD.headerText3Value;
            if (tieredType == "fixed") {
                tbl2Hdr3Vlu = tbl2Hdr3Vlu + " Amount";
            }
            else if (tieredType == "percentage") {
                tbl2Hdr3Vlu = tbl2Hdr3Vlu + " %";
            }
            jQuery(tableSelector).before('<div id="tieres" class="table-second"><table><thead><tr><th class="custom-block1 heading">' + commonFields_PD.headerText1Value + '</th><th class="custom-block2 heading">' + commonFields_PD.headerText2Value + '</th><th class="custom-block3 heading">' + tbl2Hdr3Vlu + '</th></tr></thead><tbody id="table-2-data"></tbody></table></div>');
        }

        if (commonFields_PD.tableSetting == "table3") {
            jQuery(tableSelector).before('<div id="tieres" class="table-third"><table><thead><tr><th class="custom-block1 heading">' + commonFields_PD.headerText1Value + '</th><th class="custom-block2 heading">' + commonFields_PD.headerText2Value + '</th><th class="custom-block3 heading">' + commonFields_PD.headerText3Value + '</th></tr></thead><tbody id="table-3-data"></tbody></table></div>');
        }

        if (commonFields_PD.tableSetting == "table4") {
            jQuery(tableSelector).before('<div id="tieres" class="table-fourth"><table><thead><tr><th class="custom-block1 heading">' + commonFields_PD.headerText1Value + '</th><th class="custom-block2 heading">' + commonFields_PD.headerText2Value + '</th></tr></thead><tbody id="table-4-data"></tbody></table></div>');
        }

        if (commonFields_PD.tableSetting == "table5") {
            var tbl5Hdr4Vlu = commonFields_PD.headerText4Value;
            if (tieredType == "fixed") {
                tbl5Hdr4Vlu = tbl5Hdr4Vlu + " Amount";
            }
            else if (tieredType == "percentage") {
                tbl5Hdr4Vlu = tbl5Hdr4Vlu + " %";
            }
            jQuery(tableSelector).before('<div id="tieres" class="table-fifth"><table><thead><tr><th class="custom-block1 heading">' + commonFields_PD.headerText1Value + '</th><th class="custom-block2 heading">' + commonFields_PD.headerText2Value + '</th><th class="custom-block3 heading">' + commonFields_PD.headerText3Value + '</th><th class="custom-block4 heading">' + tbl5Hdr4Vlu + '</th></tr></thead><tbody id="table-5-data"></tbody></table></div>');
        }

        if (commonFields_PD.tableSetting == "table6") {
            var tbl6Hdr3Vlu = commonFields_PD.headerText3Value;
            if (tieredType == "fixed") {
                tbl6Hdr3Vlu = tbl6Hdr3Vlu + " Amount";
            }
            else if (tieredType == "percentage") {
                tbl6Hdr3Vlu = tbl6Hdr3Vlu + " %";
            }
            jQuery(tableSelector).before('<div id="tieres" class="table-sixth"><table><thead><tr><th class="custom-block1 heading">' + commonFields_PD.headerText1Value + '</th><th class="custom-block2 heading">' + commonFields_PD.headerText2Value + '</th><th class="custom-block3 heading">' + tbl6Hdr3Vlu + '</th></tr></thead><tbody id="table-6-data"></tbody></table></div>');
        }
    }

    var WriteTableRows = function (tieredSplit_, selectedVariant_) {
        var tieredType = tieredSplit_[0].trim();
        var originalPrice_ = commonFields_PD.variantsPriceArray_PD[selectedVariant_];
        originalPrice_ = originalPrice_ / 100;
        for (i = 6; i < tieredSplit_.length; i++) {
            var isBreakLoop = false;
            var tieredRange_ = tieredSplit_[i].split("=")[0];
            var tieredOff = tieredSplit_[i].split("=")[1];
            tieredOff = Number(tieredOff);
            var tieredMin_ = parseInt(tieredRange_.split("-")[0]);
            var tieredMax_ = tieredRange_.split("-")[1];
            var discountedPrice = 0;

            if (tieredMax_ != "max") {
                tieredMax_ = parseInt(tieredRange_.split("-")[1]);
            }
            else {
                tieredMax_ = "+";
            }

            if (tieredType == "percentage") {
                discountedPrice = originalPrice_;
                discountedPrice = discountedPrice.toFixed(2);
                discountedPrice = Number(discountedPrice);
                var p = parseFloat(tieredOff) / 100;
                var originalPriceCut_ = parseFloat(p * discountedPrice);
                originalPriceCut_ = originalPriceCut_.toFixed(2);
                originalPriceCut_ = Number(originalPriceCut_);
                discountedPrice = discountedPrice - originalPriceCut_;
                if (discountedPrice <= 0) {
                    discountedPrice = 0;
                    tieredOff = "100%";
                    isBreakLoop = true;
                    tieredMax_ = "+";
                }
                else {
                    discountedPrice = discountedPrice.toFixed(2);
                    tieredOff = tieredOff + "%";
                }
            }
            else if (tieredType == "fixed_price") {
                discountedPrice = tieredOff;
                discountedPrice = discountedPrice.toFixed(2);
                discountedPrice = Number(discountedPrice);
                discountedPrice = discountedPrice.toFixed(2);
                tieredOff = globalFields.currencySymbol + tieredOff;
            }
            else {
                discountedPrice = originalPrice_ - tieredOff;
                discountedPrice = discountedPrice.toFixed(2);
                discountedPrice = Number(discountedPrice);
                if (discountedPrice <= 0) {
                    discountedPrice = 0;
                    tieredOff = globalFields.currencySymbol + originalPrice_;
                    isBreakLoop = true;
                    tieredMax_ = "+";
                }
                else {
                    discountedPrice = discountedPrice.toFixed(2);
                    tieredOff = globalFields.currencySymbol + tieredOff;
                }
            }

            TableRowSingle(tieredMin_, tieredMax_, discountedPrice, tieredOff);

            if (isBreakLoop) {
                break;
            }
        }
    }

    var TableRowSingle = function (tieredMin_, tieredMax_, discountedPrice, tieredOff) {
        if (commonFields_PD.tableSetting == "table1") {
            jQuery('#table-1-data').append('<tr><td class="custom-block1 bdcontent">' + tieredMin_ + '+</td><td class="custom-block2 bdcontent"><span class="money" data-currency-usd="' + globalFields.currencySymbol + discountedPrice + '">' + globalFields.currencySymbol + discountedPrice + '</span></td></tr>');
        }

        if (commonFields_PD.tableSetting == "table2") {
            jQuery('#table-2-data').append('<tr><td class="custom-block1 bdcontent">Buy ' + tieredMin_ + '+</td><td class="custom-block2 bdcontent"><span class="money" data-currency-usd="' + globalFields.currencySymbol + discountedPrice + '">' + globalFields.currencySymbol + discountedPrice + '</span></td><td class="custom-block3 bdcontent">' + tieredOff + '</td></tr>');
        }

        if (commonFields_PD.tableSetting == "table3") {
            jQuery('#table-3-data').append('<tr><td class="custom-block1 bdcontent">' + tieredMin_ + '</td><td class="custom-block2 bdcontent">' + tieredMax_ + '</td><td class="custom-block3 bdcontent"><span class="money" data-currency-usd="' + globalFields.currencySymbol + discountedPrice + '">' + globalFields.currencySymbol + discountedPrice + '</span></td></tr>');
        }

        if (commonFields_PD.tableSetting == "table4") {
            var quantityTextTable4 = tieredMin_ + "-" + tieredMax_;
            if (tieredMax_ == "+") {
                quantityTextTable4 = tieredMin_ + "+";
            }
            jQuery('#table-4-data').append('<tr><td class="custom-block1 bdcontent">Buy ' + quantityTextTable4 + '</td><td class="custom-block2 bdcontent"><span class="money" data-currency-usd="' + globalFields.currencySymbol + discountedPrice + '">' + globalFields.currencySymbol + discountedPrice + '</span></td></tr>');
        }

        if (commonFields_PD.tableSetting == "table5") {
            jQuery('#table-5-data').append('<tr><td class="custom-block1 bdcontent">' + tieredMin_ + '</td><td class="custom-block2 bdcontent">' + tieredMax_ + '</td><td class="custom-block3 bdcontent"><span class="money" data-currency-usd="' + globalFields.currencySymbol + discountedPrice + '">' + globalFields.currencySymbol + discountedPrice + '</span></td><td class="custom-block4 bdcontent">' + tieredOff + '</td></tr>');
        }

        if (commonFields_PD.tableSetting == "table6") {
            var quantityTextTable6 = tieredMin_ + "-" + tieredMax_;
            if (tieredMax_ == "+") {
                quantityTextTable6 = tieredMin_ + "+";
            }
            jQuery('#table-6-data').append('<tr><td class="custom-block1 bdcontent">Buy ' + quantityTextTable6 + '</td><td class="custom-block2 bdcontent"><span class="money" data-currency-usd="' + globalFields.currencySymbol + discountedPrice + '">' + globalFields.currencySymbol + discountedPrice + '</span></td><td class="custom-block3 bdcontent">' + tieredOff + '</td></tr>');
        }
    }

}

var commonFields_PD = new VGTierApp.PDPage.Global();
var displayTiers = new VGTierApp.PDPage.DisplayTiers();
displayTiers.DisplayTiersFn();
displayTiers.OnVariantChange();